import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/users/page';

export const Route = createFileRoute('/_app/settings/users/')({
  component: Page,
});
